export const levels: string[] = [
    '30 kyu',
    '29 kyu',
    '28 kyu',
    '27 kyu',
    '26 kyu',
    '25 kyu',
    '24 kyu',
    '23 kyu',
    '22 kyu',
    '21 kyu',
    '20 kyu',
    '19 kyu',
    '18 kyu',
    '17 kyu',
    '16 kyu',
    '15 kyu',
    '14 kyu',
    '13 kyu',
    '12 kyu',
    '11 kyu',
    '10 kyu',
    '9 kyu',
    '8 kyu',
    '7 kyu',
    '6 kyu',
    '5 kyu',
    '4 kyu',
    '3 kyu',
    '2 kyu',
    '1 kyu',
    '1 dan',
    '2 dan',
    '3 dan',
    '4 dan',
    '5 dan',
    '6 dan',
    '7 dan',
    '8 dan',
    '9 dan',
];
export const genres: string[] = [
    'life and death',
    'joseki',
    'fuseki',
    'tesuji',
    'best move',
    'endgame',
];
export const problemStatus = {
    untried: 'problems_filter.untried',
    tried_but_not_solved: 'problems_filter.tried_but_not_solved',
    solved: 'problems_filter.solved',
};
